// extracted by mini-css-extract-plugin
export default {"production_wrapper":"KatalogNavigation_production_wrapper__M+C8s","content":"KatalogNavigation_content__l1Puy","content_item":"KatalogNavigation_content_item__RkafG"};